import React from 'react';
import { Card, CardProps } from 'antd';
import { theme } from '../../theme';

interface StyledCardProps extends Omit<CardProps, 'styles'> {
  /**
   * Si true, aplica el header con fondo azul oscuro
   * @default true
   */
  darkHeader?: boolean;
  /**
   * Permite sobrescribir los estilos del header
   */
  headerStyle?: React.CSSProperties;
  /**
   * Permite sobrescribir los estilos del body
   */
  bodyStyle?: React.CSSProperties;
}

/**
 * Componente Card reutilizable con estilos consistentes del theme
 * Aplica automáticamente sombras, border-radius y estilos de header
 */
export const StyledCard: React.FC<StyledCardProps> = ({ 
  darkHeader = true,
  headerStyle = {},
  bodyStyle = {},
  style = {},
  children,
  ...restProps 
}) => {
  const cardStyles = darkHeader ? {
    header: { 
      backgroundColor: theme.colors.primaryDark, 
      color: theme.colors.textLight,
      fontSize: '16px',
      fontWeight: 600,
      ...headerStyle
    },
    body: bodyStyle
  } : {
    body: bodyStyle
  };

  return (
    <Card 
      styles={cardStyles}
      style={{ 
        marginBottom: '24px',
        boxShadow: theme.shadows.md,
        borderRadius: theme.borderRadius.lg,
        ...style
      }}
      {...restProps}
    >
      {children}
    </Card>
  );
};

